<template>
  <div>
    <header class="header-global fixed-top">
      <base-nav
        class="navbar-main headroom"
        id="navbar-main"
        :type="navbarType ? navbarType : 'anhod1'"
        effect="dark"
        expand
      >
        <router-link
          slot="brand"
          class="navbar-brand mr-lg-5"
          to="/recouvrement"
        >
          <img src="img/brand/logo.png" alt="logo" style="height: 70px;" />
          Arcos
        </router-link>

        <ul
          class="navbar-nav navbar-nav-hover align-items-lg-center ml-lg-auto"
        >
          <li class="nav-item">
            <router-link to="/">
              <a class="nav-link"
                ><i class="ni ni-curved-next"></i> Retourner à l'accueil</a
              >
            </router-link>
          </li>
        </ul>
      </base-nav>
    </header>
    <center>
      <div id="main" class="pt-150">
        <b>ARCOS RECOUVREMENT</b>
        <br />
        16 avenue Charles de Gaulle - 31130 BALMA
        <br />
        Tél. 05.61.83.29.13
        <br />
        Directeur de la publication : Hugues Ousteau
        <br /><br />
        Pour son activité de recouvrement, le cabinet <b>ARCOS</b> agit selon
        les articles R124-4 à R 124-7 du code de procédure civile d’exécution.
        <br />
        Son activité de recouvrement est déclaré au procureur de la République
        près du tribunal de grande instance de Toulouse.
        <br />
        <br />
        <div class="row">
          <div class="col-md-4"></div>
          <div class="col-md-4 pt-50" id="btn">
            <router-link to="/">
              <base-button block type="anhod2" text-color="white">
                Retourner à l'accueil
              </base-button>
            </router-link>
          </div>
          <div class="col-md-4"></div>
        </div>
      </div>
    </center>
  </div>
</template>

<script>
import BaseNav from "@/components/BaseNav";
export default {
  name: "MentionsLegales",
  components: {
    BaseNav
  },
  data() {
    return {
      modals: {
        modal4: false
      }
    };
  }
};
</script>

<style scoped>
li {
  margin-right: 7%;
}
@media screen and (max-height: 992px) {
  #main {
    padding-top: 8em;
  }
  #btn {
    margin-top: -1.5em;
  }
}
</style>
